// extracted by mini-css-extract-plugin
module.exports = {"root":"umKCp1R90Wtvs8qxYoYw"};